var tmCurrencies;

tmCurrency = function () {

    return {

        selectedTmCurrency: null,

        getTmCurrencyByCode: function (currencyCode) {
            if (currencyCode !== null) {
                currencyCode = currencyCode.toUpperCase();
            }
            if (tmCurrencies[currencyCode]) {
                return tmCurrencies[currencyCode];
            }
            return null;
        },

        changeCurrency: function (currencyCode, fromCheckoutPage = false) {
            // return if invalid code
            if (tmCurrency.getTmCurrencyByCode(currencyCode) === null) {
                return;
            }

            // save to instance
            tmCurrency.selectedTmCurrency = tmCurrency.getTmCurrencyByCode(currencyCode);

            // Save to cookie.
            if (typeof tmVisitorStore !== 'undefined') { // possible from booking edit.
                tmVisitorStore.setCurrency(tmCurrency.selectedTmCurrency.code);
            }

            // trigger update Html Els
            tmCurrency.currencyUpdateEls(true);

            // a selection closes the popup (Peter, 2026-09-14 — it had stayed open since a77431e800)
            if (!fromCheckoutPage) {
                tmCurrency.closeCurrencyLanguageModal();
            }
            else {
                let tmCurrencyModal = Modal.instance('#c-currency-modal');
                if (tmCurrencyModal !== null) {
                    tmCurrencyModal.showLoader();
                }
            }

            // document trigger, allow other listeners to make changes.
            jQuery(document).trigger('tm_currency_changed', {selectedTmCurrency: tmCurrency.selectedTmCurrency});
        },

        /* "USD ($)" — the code with its symbol in brackets, as the picker rows print it (components/checkbox-list.php) */
        currencyCodeWithSymbol: function (currency) {
            let symbol = (currency.symbol || '').trim();
            return symbol.length > 0 ? currency.code + ' (' + symbol + ')' : currency.code;
        },

        closeCurrencyLanguageModal: function () {
            try {
                let tmCurrencyModal = Modal.instance('#c-currency-modal');
                if (tmCurrencyModal !== null) {
                    tmCurrencyModal.hideLoader();
                    tmCurrencyModal.close();
                }

                let tmLanguageModal = Modal.instance('#c-language-modal');
                if (tmLanguageModal !== null) {
                    tmLanguageModal.hideLoader();
                    tmLanguageModal.close();
                }
            } catch (e) {}
        },

        /*setUpCurrencyListener: function() {
            let requestedCurrencyCode;

            let currencyCodeFromGetParam = tmUtils.getParameterFromUrl('currency', window.location.href);
            currencyCodeFromGetParam = currencyCodeFromGetParam !== null ? currencyCodeFromGetParam.toUpperCase() : null;

            if(currencyCodeFromGetParam && tmCurrency.getTmCurrencyByCode(currencyCodeFromGetParam) !== null) {
                requestedCurrencyCode = currencyCodeFromGetParam;
            }
            else {
                let browserSavedCurrencyCode = tmVisitorStore.getCurrency();
                requestedCurrencyCode = tmCurrency.getTmCurrencyByCode(browserSavedCurrencyCode) !== null ? browserSavedCurrencyCode : null;
            }
            requestedCurrencyCode = requestedCurrencyCode || 'USD';
            tmVisitorStore.setCurrency(requestedCurrencyCode);

            tmCurrency.updateCurrencies(true);

        },

        updateCurrencies: function (forceUpdate = false) {
            let savedCurrencyCode = tmVisitorStore.getCurrency();
            let selectedTmCurrency = tmCurrency.getTmCurrencyByCode(savedCurrencyCode);
            if (selectedTmCurrency !== null) {
                // checkout page updates

                // data selectors update
                let selector = '.tm-price-display-element.tm-price-is-loading';

                if(forceUpdate) {
                    selector = '.tm-price-display-element';
                }

                let elements = document.querySelectorAll(selector);

                elements.forEach((element) => {
                    let amountInUsd = element.getAttribute('data-usd-price');
                    let useSmallCurrencySymbol = parseInt(element.getAttribute('data-small-currency-symbol'));

                    let convertedValue = tmCurrency.convertUsdAmountToCurrencyMajorUnit(selectedTmCurrency.code, amountInUsd, true);

                    if(useSmallCurrencySymbol) {
                        element.innerHTML = `<small>${selectedTmCurrency.symbol}</small>${convertedValue}`;
                    }
                    else {
                        element.innerHTML = `${selectedTmCurrency.symbol}${convertedValue}`;
                    }

                    element.classList.add('tm-price-is-loaded');
                    element.classList.remove('tm-price-is-loading');
                });

            }
        },*/

        // The selected currency row sits at the top of the picker list. Runs on page load and each time the
        // picker opens - not when a currency is clicked, so the list does not jump under the visitor's finger.
        moveSelectedRowFirst: function () {
            // mark the selected currency's row first: outside the checkout the row class is not updated on click,
            // so the marker has to come from the stored selection or nothing would move on the next open
            if (tmCurrency.selectedTmCurrency && tmCurrency.selectedTmCurrency.code) {
                jQuery('.tm-currency-item-row').removeClass('c-checkbox-item-selected');
                jQuery('.tm-currency-item-row[data-code="' + tmCurrency.selectedTmCurrency.code + '"]').addClass('c-checkbox-item-selected');
            }
            jQuery('.tm-currency-item-row.c-checkbox-item-selected').each(function () {
                let list = this.parentElement;
                if (list && list.firstElementChild !== this) { list.insertBefore(this, list.firstElementChild); }
            });
        },

        currencyUpdateEls: function (forceUpdate = false) {
            if (tmCurrency.selectedTmCurrency === null) {
                return;
            }

            // header
            let currentLanguage = jQuery('.gt-current-lang').attr('data-gt-lang') ?? 'en';
            jQuery('.c-span-language').text(currentLanguage.toUpperCase()); // todo: language move to other place?
            jQuery('.c-span-currency').text(tmCurrency.selectedTmCurrency.funLabel)
            jQuery('.c-span-currency-code').text(tmCurrency.selectedTmCurrency.code)
            jQuery('.c-span-currency-sign').text(tmCurrency.selectedTmCurrency.symbol)
            jQuery('.datepicker-currency-short').text(tmCurrency.currencyCodeWithSymbol(tmCurrency.selectedTmCurrency)) // calendar footer "Prices in USD ($)"
            jQuery('.datepicker-currency-sign').text(tmCurrency.selectedTmCurrency.symbol)

            // non-checkout pages
            let selector = '.tm-price-display-element.tm-price-is-loading';
            if(forceUpdate) {
                selector = '.tm-price-display-element';
            }
            jQuery(selector).each(function (index, elem) {
                let amountInUsd = jQuery(elem).attr('data-usd-price');
                let negativeSignPrefix = amountInUsd < 0 ? '-' : '';
                let replaceDotZeros = jQuery(elem).attr('data-replace-dot-zeros') !== undefined;
                let isDisplayAbbreviatedFormat = jQuery(elem).attr('data-display-abbreviated-format') !== undefined;
                let roundPrice = jQuery(elem).attr('data-round-price') !== undefined; // product cards/carousels: whole units
                let formattedValueInCurrencyMajorUnit = tmCurrency.convertUsdAmountToCurrencyMajorUnit(tmCurrency.selectedTmCurrency.code, Math.abs(amountInUsd), true, replaceDotZeros, isDisplayAbbreviatedFormat, roundPrice);
                let displayPrefixType = jQuery(elem).attr('data-display-prefix-type') ?? 'label';
                let displayPrefixValue = '';
                // 'symbol' only when it is a true symbol ($ € £ …); an alphabetic one (kr) renders as the label (SEK) so
                // prices read the same everywhere — the header menu and picker read .symbol directly and keep kr
                if (['symbol', 'smallSymbol'].includes(displayPrefixType) && !/\p{L}/u.test(tmCurrency.selectedTmCurrency.symbol)) {
                    displayPrefixValue = tmCurrency.selectedTmCurrency.symbol;
                }
                else if (['label', 'smallLabel', 'symbol', 'smallSymbol'].includes(displayPrefixType)) {
                    displayPrefixValue = tmCurrency.selectedTmCurrency.label;
                }
                displayPrefixValue = negativeSignPrefix + displayPrefixValue;
                if (['smallLabel', 'smallSymbol'].includes(displayPrefixType)) {
                    jQuery(elem).html(`<small>${displayPrefixValue}</small>${formattedValueInCurrencyMajorUnit}`);
                }
                else {
                    jQuery(elem).html(`${displayPrefixValue}${formattedValueInCurrencyMajorUnit}`);
                }
                jQuery(elem).removeClass('tm-price-is-loading');
            });
            jQuery(document).trigger('tmCurrencyElsUpdated'); // prices are now in the selected currency (widget line rows re-measure)

            if (forceUpdate) {
                // Currency modal update selected row (checkout page)
                jQuery('.tm-currency-item-row').removeClass('c-checkbox-item-selected')
                jQuery('.tm-currency-item-row[data-code="'+tmCurrency.selectedTmCurrency.code+'"]').addClass('c-checkbox-item-selected');
                // update selected current symbol/code (checkout page)
                jQuery('.c-currency-switcher-sign').text(tmCurrency.selectedTmCurrency.symbol);
                jQuery('.c-currency-switcher-short').text((tmCurrency.selectedTmCurrency.code).toUpperCase());
            }
        },

        convertToNumber: function (value, decimals = 2, format = false) {
            let factor = Math.pow(10, decimals);

            // Fix floating point issues before ceil
            let scaled = Math.ceil((Math.round((value + Number.EPSILON) * factor * 1e10) / 1e10));
            let number = scaled / factor;

            if (format) {
                // Convert to string with fixed decimals
                let str = number.toFixed(decimals);
                let parts = str.split('.');

                let integerPart = parts[0];
                let decimalPart = parts[1] || '';

                // Add thousands separator
                integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

                number = decimals > 0 ? `${integerPart}.${decimalPart}` : integerPart;
            }
            else {
                number = parseFloat(number.toFixed(decimals)); // ensure consistent decimal places
            }

            return number;
        },

        convertUsdAmountToCurrencyMajorUnit: function (currencyCode, amountInUsd, format = false, replaceDotZeros = false, abbreviatedFormat = false, roundToWhole = false) {
            let amountInCurrency = 0;
            let selectedTmCurrency = tmCurrencies[currencyCode] ?? null;
            if (selectedTmCurrency) {
                // do not mix format here.
                amountInCurrency = tmCurrency.convertToNumber(amountInUsd * selectedTmCurrency.rate, selectedTmCurrency.isZeroDecimal ? 0 : 2, false);
            }
            if (roundToWhole && !abbreviatedFormat) {
                // product cards / carousels show whole units in every currency (product pages keep the exact price)
                amountInCurrency = Math.round(amountInCurrency);
                return format ? tmCurrency.convertToNumber(amountInCurrency, 0, true) : amountInCurrency;
            }
            if (abbreviatedFormat) {
                if (amountInCurrency >= 1_000_000_000) {
                    amountInCurrency = (amountInCurrency / 1_000_000_000).toFixed(0) + "B";
                }
                else if (amountInCurrency >= 1_000_000) {
                    amountInCurrency = (amountInCurrency / 1_000_000).toFixed(0) + "M";
                }
                else if (amountInCurrency >= 1_000_0) {
                    amountInCurrency = (amountInCurrency / 1_000).toFixed(0) + "K";
                }
                else if (amountInCurrency >= 1_000) {
                    amountInCurrency = (amountInCurrency / 1_000).toFixed(1) + "K";
                }
                else {
                    if (roundToWhole) {
                        // abbreviated + whole units (booking calendar day prices): no decimals below 1,000 either
                        amountInCurrency = Math.round(amountInCurrency);
                        return format ? tmCurrency.convertToNumber(amountInCurrency, 0, true) : amountInCurrency;
                    }
                    if (format) {
                        amountInCurrency = tmCurrency.convertToNumber(amountInCurrency, 2, true);
                        if (replaceDotZeros) {
                            amountInCurrency = amountInCurrency.replaceAll('.00', '');
                        }
                    }
                }
            }
            else if (format) {
                amountInCurrency = tmCurrency.convertToNumber(amountInCurrency, 2, true);
                if (replaceDotZeros) {
                    amountInCurrency = amountInCurrency.replaceAll('.00', '');
                }
            }
            return amountInCurrency;
        },

        getUsdCurrencyHtmlDataTag: function(amount, smallSymbol = false, replaceDotZeros = true, displayAbbreviatedFormat = false, labelOrSymbol = 'label', roundPrice = false) {
            let usdPrice = (amount.replaceAll && amount.replaceAll(',', '')) || amount;
            let value = usdPrice * 100;

            let formattedUsdPrice = tmCurrency.convertUsdAmountToCurrencyMajorUnit('USD', usdPrice, true, replaceDotZeros, false, roundPrice);

            let replaceDotZerosAttr = replaceDotZeros ? 'data-replace-dot-zeros' : '';
            let displayAbbreviatedFormatAttr = displayAbbreviatedFormat ? 'data-display-abbreviated-format' : '';
            let roundPriceAttr = roundPrice ? 'data-round-price' : ''; // whole units in every currency (same as product cards)
            let labelSymbolAttr = 'data-display-prefix-type="'+labelOrSymbol+'"'

            let usdPrefix = labelOrSymbol === 'none' ? '' : '$'; // 'none': no currency prefix
            let tag = `<data class="tm-price-display-element tm-price-is-loading notranslate" ${labelSymbolAttr} ${replaceDotZerosAttr} ${displayAbbreviatedFormatAttr} ${roundPriceAttr} data-usd-price="${usdPrice}" value="${value}">${usdPrefix}${formattedUsdPrice}</data>`;

            if(smallSymbol) {
                tag = `<data class="tm-price-display-element tm-price-is-loading notranslate" ${labelSymbolAttr} ${replaceDotZerosAttr} ${displayAbbreviatedFormatAttr} ${roundPriceAttr} data-usd-price="${usdPrice}" value="${value}"><small>$</small>${formattedUsdPrice}</data>`;
            }
            return tag;
        }
    }
}(window);


/* Currency custom events and listeners */
(function() {
    jQuery('.tm-currency-item-row').click(function () {
        let selectedCurrencyCode = jQuery(this).attr('data-code');
        tmCurrency.changeCurrency(selectedCurrencyCode, $(this).hasClass('checkout-page---tm-currency-item-row'));
    });

    jQuery(function () { tmCurrency.moveSelectedRowFirst(); });
    jQuery(document).on('tmModal_open_#c-language-modal tmModal_open_#c-currency-modal', function () { tmCurrency.moveSelectedRowFirst(); });

    jQuery(document).on('tmWidgetBookingLoaded tmActivitiesSubsetListRefreshed tmRenderCalendarComplete calculateTotals tmBookingWidgetTotalsUpdated tmBookingEditTotalsUpdated tmPriceFilterSliderUpdated searchResultsUpdated tmChildProductIdChanged tmCheckoutUpdated gTranslateLanguageSelected', function () {
        tmCurrency.currencyUpdateEls();
    });

    /* some elements are rendered on the same events. so wait for them. */
    jQuery(document).on('tmBlogUserLoginStatusChanged', function () {
        setTimeout(function () { tmCurrency.currencyUpdateEls(); }, 200);
    });
})();
